import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose, mapObject, constant } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { getObjectiveItemStyles } from '../styles';
import { StyledSelectableItem } from './selectable-item';

const MaxDescriptionLength = 36;

class ObjectiveItem extends React.PureComponent {
  helpKeyDown = (event) => {
    if ((event.keyCode === 13) || (event.keyCode === 32)) {
      this.helpClick(event);
      event.stopPropagation();
    }
  };

  helpClick = (event) => {
    window.PopupController.PopupJsClick(event.target);
    event.stopPropagation();
  };

  handleDescription = (description) => {
    const wordArray = description.split(' ');
    let updatedDescription = description;
    while (updatedDescription.length > MaxDescriptionLength) {
      wordArray.pop();
      updatedDescription = `${wordArray.join(' ')}...`;
    }

    return updatedDescription;
  };

  renderObjectiveItemContent = () => {
    const {
      classes,
      iconName,
      descriptionLine,
      helpId,
      helpArialLabel,
      onClick,
      isNewFeature,
      showFACBadge,
      FACInfo,
      isSVGIcon,
      i18n,
    } = this.props;

    const description = this.handleDescription(descriptionLine);
    const rootClass = classNames('objective-item', 'wider-objective-item');

    return (
      <StyledSelectableItem {...this.props} onClick={onClick} className={rootClass} >
        <div className={`${classes.objectiveItemContent} campaign-objective-content`}>
          {isSVGIcon ? (<span
            className={classNames(classes.objectiveIcon, `icon-${iconName}`)}
          />) : (<Glyphicon
            className={`${classes.objectiveIcon} icon-${iconName}`}
            glyph={`ba-${iconName}`}
          />)}
          <div className={`${classes.objectiveDescription} objective-description`}>
            <div className="description-line">{description}</div>
          </div>
          <button className={`${classes.objectiveHelpIcon} helpbutton icon-Unknow`} type="helppopup" topic={helpId} data-help="data-help" onClick={this.helpClick} onKeyDown={this.helpKeyDown} aria-label={helpArialLabel} />
          {
            isNewFeature ?
              <div className={`${classes.newFeatureLabel} new-feature-label`}>{i18n.getString(_TL_('New'))}</div>
              : ''
          }
          {
            showFACBadge && FACInfo ?
              <div className={`${classes.facLabel} fac-label`}>{i18n.getString(_TL_('{{CouponValue}} off'), { CouponValue: FACInfo.CouponValueWithCurrency })}</div>
              : ''
          }
        </div>
      </StyledSelectableItem>);
  };

  render() {
    const {
      classes,
    } = this.props;

    return (
      <div className={`${classes.objectiveItem} campaign-objective`}>
        {this.renderObjectiveItemContent()}
      </div >
    );
  }
}

ObjectiveItem.propTypes = {
  classes: PropTypes.shape(mapObject(
    getObjectiveItemStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  id: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  descriptionLine: PropTypes.string.isRequired,
  helpId: PropTypes.string,
  onClick: PropTypes.func,
  isSVGIcon: PropTypes.bool,
  'aria-label': PropTypes.string,
  isSelected: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  helpArialLabel: PropTypes.string,
  isNewFeature: PropTypes.bool,
  showFACBadge: PropTypes.bool,
  FACInfo: PropTypes.shape({
    CouponValueWithCurrency: PropTypes.string,
  }),
  ariaItemSize: PropTypes.number.isRequired,
  ariaItemIndex: PropTypes.number.isRequired,
};

ObjectiveItem.defaultProps = {
  helpId: null,
  onClick: null,
  isSVGIcon: false,
  'aria-label': '',
  isSelected: false,
  helpArialLabel: null,
  isNewFeature: false,
  showFACBadge: false,
  FACInfo: null,
};

const wrap = compose(
  TempComponent => withDefaultStyles(TempComponent, getObjectiveItemStyles),
  withI18nConsumer
);

export const StyledObjectiveItem = wrap(ObjectiveItem);
